import React, { Component, Fragment } from 'react'
import cn from 'classnames'

import CheckBox from 'app/components/CheckBox/index'
import IconButton from 'app/domains/common/IconButton/index'
import Link from 'app/components/SVGS/Link'

import './styles.scss'
export const bc = 'textarea-with-editors-options'

class TextAreaWithEditorsOptions extends Component {
  constructor(props) {
    super(props)
    this.textareaRef = null

    this.setTextInputRef = element => {
      this.textareaRef = element
    }
  }

  state = {
    isPreview: this.props.input.value || false,
  }

  render() {
    const { isPreview } = this.state
    const { t, showModal, classTextArea, meta: { touched, error }, placeholder, input } = this.props
    return (
      <Fragment>
        <div className={bc}>
          <CheckBox
            className={`${bc}__checkbox`}
            label={t('Show Editor')}
            input={{
              value: !isPreview,
              onChange: () => this.setState({ isPreview: !isPreview }),
            }}
          />
          <IconButton
            onClick={e => {
              e.preventDefault()
              showModal(this.textareaRef)
            }}
            disabled={!!isPreview}
          >
            <Link />
          </IconButton>
        </div>
        {isPreview ? (
          <div
            className={cn(`${bc}__field`, `${bc}__field-div`, {
              error: touched && error,
            })}
            dangerouslySetInnerHTML={{ __html: input.value }}
          />
        ) : (
          <textarea
            className={cn(`${bc}__field`, classTextArea, {
              error: touched && error,
            })}
            id={`input-${input.name}`}
            placeholder={placeholder}
            ref={this.setTextInputRef}
            {...input}
          />
        )}
      </Fragment>
    )
  }
}

export default TextAreaWithEditorsOptions
